<template>
    <div id="worksRoot">
        <div id="worksGrid">
            <div>
                <!-- Julio card -->
                <router-link :to="'/work/' + 0">
                    <div id="julioCard" class="cardContainer"
                         @mouseover="julioTileHover = true"
                         @mouseleave="julioTileHover = false" @touchstart="(julioTileHover = true), (hover = true)"
                         @touchend="(julioTileHover = false), (hover = false)"
                         @click="(julioIconHover = !julioIconHover), (hover = false)">
                        <div class="imageContainer">
                        <span class="imageSpan">
                            <img :class="julioBackPlate" src="../assets/julio-back-plate.svg"/>
                        </span>
                            <span class="imageSpan">
                            <img :class="julioEye" src="../assets/julio-eye.svg"/>
                        </span>
                        </div>
                        <img class="titleSpan"
                             @mouseover="julioIconHover = true"
                             @mouseleave="julioIconHover = false"
                             :class="julioTitleClass"
                             src="../assets/julio-text.svg"/>
                    </div>
                </router-link>
                <!-- Grocery boy card-->
                <router-link :to="'/work/' + 1">
                    <div id="groceryboy" class="cardContainer"
                         @mouseover="groceryBoyTileHover = true"
                         @mouseleave="groceryBoyTileHover = false"
                         @touchstart="(groceryBoyTileHover = true), (hover = true)"
                         @touchend="(groceryBoyTileHover = false), (hover = false)" @click="hover = false">
                        <div class="imageContainer">
                            <span class="imageSpan"><img src="../assets/grocery-boy.svg"/></span>
                        </div>
                        <img class="titleSpan" :class="groceryBoyTitleClass"
                             src="../assets/grocery-boy-text.svg"/>
                    </div>
                </router-link>
            </div>

            <div>
                <!-- Puregym card -->
                <router-link :to="'/work/' + 2">
                    <div id="puregym" class="cardContainer"
                         @mouseover="puregymTileHover = true"
                         @mouseleave="puregymTileHover = false"
                         @touchstart="(puregymTileHover = true), (hover = true)"
                         @touchend="(puregymTileHover = false), (hover = false)" @click=" hover = false">
                        <div class="imageContainer">
                            <span class="imageSpan"><img src="../assets/puregym-logo.svg"/></span>
                        </div>
                        <img class="titleSpan" :class="puregymTitleClass"
                             src="../assets/puregym-text.svg"/>
                    </div>
                </router-link>

                <!-- IB Chemistry -->
                <router-link :to="'/work/' + 3">
                    <div id="ibChemistry" class="cardContainer"
                         @mouseover="ibChemistryTileHover = true"
                         @mouseleave="ibChemistryTileHover = false"
                         @touchstart="(ibChemistryTileHover = true), (hover = true)"
                         @touchend="(ibChemistryTileHover = false), (hover = false)" @click="hover = false">
                        <div class="imageContainer">
                            <span class="imageSpan"><img src="../assets/ib_chemistry.svg"/></span>
                        </div>
                        <img class="titleSpan" :class="ibChemistryTitleClass"
                             src="../assets/ib-chemistry-text.svg"/>
                    </div>
                </router-link>
            </div>

            <div @click="showSnackBar('')">
                <!-- Disney card -->
                <router-link @contextmenu.prevent :to="'/work/' + 5">
                    <div id="disney" class="cardContainer">
                        <div class="imageContainer">
                            <span class="imageSpan"><img src="../assets/disney.svg"/></span>
                        </div>
                        <!--                        <img class="titleSpan"-->
                        <!--                             src="../assets/puregym-text.svg"/>-->
                    </div>
                </router-link>
            </div>

            <div @click="showSnackBar('')">
                <!-- Album -->
                <router-link @contextmenu.prevent :to="'/work/' + 6">
                    <div id="stitches" class="cardContainer">
                        <div class="imageContainer">
                            <span class="imageSpan"><img src="../assets/stitches.svg"/></span>
                        </div>
                        <!--                            <img class="titleSpan"-->
                        <!--                                 src="../assets/ib-chemistry-text.svg"/>-->
                    </div>
                </router-link>
            </div>
        </div>

        <!-- Snackbar -->
        <div class="mdc-snackbar" :class="{'mdc-snackbar--open': snackBarVisibility}">
            <div class="mdc-snackbar__surface">
                <div class="mdc-snackbar__label" role="status" aria-live="polite">
                    Locked
                </div>
            </div>
        </div>
    </div>
</template>

<script>
	export default {
		name: "Works",
		props: {
			julioTileHoverProp: {
				type: Boolean,
				default: false
			},
			groceryBoyTileHoverProp: {
				type: Boolean,
				default: false
			},
			puregymTileHoverProp: {
				type: Boolean,
				default: false
			},
			ibChemistryTileHoverProp: {
				type: Boolean,
				default: false
			},
			julioIconHoverProp: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				snackBar: false,
				cardProps: {
					hover: true,
					tile: true,
					flat: true
				},
				snackbar: false,
				mode: '',
				timeout: 1000,
				text: 'Locked',
				isJulioTileHover: this.julioTileHoverProp,
				isGroceryBoyTileHover: this.groceryBoyTileHoverProp,
				isPuregymTileHover: this.puregymTileHoverProp,
				isIbChemistryTileHover: this.ibChemistryTileHoverProp,
				isJulioIconHover: this.julioIconHoverProp
			};
		},
		created() {
			document.title = "Works - OT";
		},
		computed: {
			snackBarVisibility: function () {
				return this.snackBar
			},
			julioTileHover: {
				set: function (newValue) {
					this.isJulioTileHover = newValue;
				},
				get: function () {
					return this.isJulioTileHover;
				}
			},
			groceryBoyTileHover: {
				set: function (newValue) {
					this.isGroceryBoyTileHover = newValue;
				},
				get: function () {
					return this.isGroceryBoyTileHover;
				}
			},
			ibChemistryTileHover: {
				set: function (newValue) {
					this.isIbChemistryTileHover = newValue;
				},
				get: function () {
					return this.isIbChemistryTileHover;
				}
			},
			puregymTileHover: {
				set: function (newValue) {
					this.isPuregymTileHover = newValue;
				},
				get: function () {
					return this.isPuregymTileHover;
				}
			},
			julioIconHover: {
				set: function (newValue) {
					this.isJulioIconHover = newValue;
				},
				get: function () {
					return this.isJulioIconHover;
				}
			},
			julioEye: function () {
				return {
					julioEyeExploded: this.isJulioIconHover,
					julioEyeDefault: !this.isJulioTileHover,
					julioEyeHover: this.isJulioTileHover
				};
			},
			julioBackPlate: function () {
				return {
					backPlateExploded: this.isJulioIconHover,
					backPlateDefault: !this.isJulioTileHover,
					blackPlateHover: this.isJulioTileHover
				};
			},
			julioTitleClass: function () {
				return {
					julioTitleDefault: !this.isJulioTileHover,
					julioTitleHover: this.isJulioTileHover
				};
			},
			groceryBoyTitleClass: function () {
				return {
					gbTitleDefault: !this.isGroceryBoyTileHover,
					gbTitleHover: this.isGroceryBoyTileHover
				};
			},
			puregymTitleClass: function () {
				return {
					puregymTitleDefault: !this.isPuregymTileHover,
					puregymTitleHover: this.isPuregymTileHover
				};
			},
			ibChemistryTitleClass: function () {
				return {
					ibChemistryTitleDefault: !this.isIbChemistryTileHover,
					ibChemistryTitleHover: this.isIbChemistryTileHover
				};
			}
		},
		methods: {
			showSnackBar(isLocked) {
				if (isLocked === "") {
					setTimeout(() => this.snackBar = false, 1000)
					return this.snackBar = true
				} else
					return this.snackBar = false
			}
		}
	};
</script>

<style lang="scss" src="../styles/works.scss" scoped/>